<template>
  <a-layout id="components-layout-demo-top-side-2" class="home">
    <a-layout-header :style="headerStyle">
      <img class="img" :src="form.logo" alt="" />
      <div class="loginout">
        <div @click="alarmHistory" style="position: relative"><a-icon type="alert" :class="tipActive?'danger starAlert':'danger'"/><span style="display: block;position:absolute;top:-10px;right: -7px;color:red;font-weight: 700;font-size:larger">{{tipsNum == 0?'':tipsNum}}</span></div>
        
        <div>{{ truename }}</div>
        <div>{{ date }}</div>
        <a href="javascript:;" @click="loginout" style="font-size: 14px;display: inline-block;padding-left: 10px;">{{ $t('home.logout') }}</a>
      </div>
    </a-layout-header>
    <a-layout>
      <a-layout-sider width="240" :style="siderStyle">
        <div class="nav">{{ $t('home.navigation') }}</div>
        <left-bar></left-bar>
      </a-layout-sider>

      <a-layout style="padding: 0">
        <a-layout-content
          :style="{
            background: '#fff',
            padding: '10px',
            margin: 0,
            minHeight: '280px',
            flex: 1,
            overflowY: 'auto',
          }"
        >
          <router-view></router-view>
        </a-layout-content>
        <a-layout-footer :style="footerStyle">
          <div class="name">{{ form.name }} {{ $t('home.copyright') }}</div>
          <div class="version">
            <span>Version</span>
            <span>{{ form.version }}</span>
          </div>
        </a-layout-footer>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
import { userinfo } from "@/api/user";
import { warningTip } from "@/api/record";
import { configload } from "@/api/system";
import { deleteKey } from "@/utils/storage";
import leftBar from "./Layout/leftBar.vue";
import { mapActions } from "vuex";
export default {
  components: {
    leftBar,
  },
  data() {
    return {
      collapsed: false,
      tipsNum:0,
      tipActive:false,
      title: "粮库综合展示",
      truename: "",
      date: "",
      siderStyle: {
        background: "#eee",
        padding: "10px",
        overflowY: "auto",
        height: "100%",
      },
      headerStyle: {
        backgroundColor: "#3a5ac4",
        padding: "10px",
        display: "flex",
        boxSizing: "border-box",
        justifyContent: "space-between",
        color: "#fff",
        height: "80px",
      },
      footerStyle: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "15px 20px",
        borderTop: "1px solid #eee",
        backgroundColor: "#fff",
      },
      form: {},
    };
  },
  created() {
    this.getconfig();
    this.getinfo();
    let that = this;
    this.timer = setInterval(() => {
      let newdate = new Date(),
        hh = this.gettime(newdate.getHours()),
        mm = this.gettime(newdate.getMinutes()),
        ss = this.gettime(newdate.getSeconds()),
        apm = hh > 12 ? "PM" : "AM";
      if (hh > 12) {
        hh = this.gettime(hh - 12);
      }
      this.date = `${hh}:${mm}:${ss} ${apm}`;
    }, 1000);
  },
  methods: {
    ...mapActions(["setAdmin"]),
    // 读取配置
    async getconfig() {
      let res = await configload();
      this.form = Object.assign({}, res.data);
      this.form.logo && (this.form.logo = res.data.logo.split(",")[1]);
    },
    async getinfo() {
      let res = await userinfo();
      if (res) {
        this.truename = res.data.truename;
        this.setAdmin({ isAdmin: res.data.isAdmin });
      }
    },

    async getWarningTips() {
      let res = await warningTip();
      let sums = 0
      if (res && res.data.length>0) {
        for(let i=0;i<res.data.length;i++){
          let wStatus = res.data[i].warnStatus
          if(wStatus!='0,0,0'){
            sums = sums + 1
          }
        }
        this.tipsNum = sums
      }
      if(sums>0){
        this.tipActive = true
      }else{
        this.tipActive = false
      }
    },

    alarmHistory(){
      this.$router.push({ path: "/alarm-record" });
    },

    gettime(val) {
      if (val < 10) {
        return "0" + val;
      } else {
        return val;
      }
    },
    loginout() {
      deleteKey("token");
      deleteKey("username");
      this.$message.success(this.$t('home.logoutTip'), 1, () => {
        this.$router.push({ path: "/login" });
      });
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  .loginout {
    display: flex;
    font-size: rem(24);
    align-items: center;
    margin-right: rem(10);
    > :nth-child(2) {
      margin: 0 rem(20);
    }
    a {
      color: #fff;
    }

    .starAlert{
        color:red;
        animation: shimmer 1.5s infinite;
      }

      @keyframes shimmer {
        0% {
          opacity: 0.2;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0.2;
        }
      }
  }
  .nav {
    font-weight: 600;
    line-height: 40px;
    background-color: #389fed;
    color: #fff;
    text-align: center;
  }
  .name {
    font-weight: 700;
  }
  .version {
    :first-child {
      font-weight: 700;
      margin-right: 5px;
    }
  }
  .img {
    width: rem(240);
  }
}
</style>
